(() => {
  const form = document.querySelector('[data-native-catalog]');
  if (!form) return;
  const price = Number(form.dataset.price) / 100;
  const confirmed = form.dataset.discounts === 'true';
  const format = value => new Intl.NumberFormat('nl-NL', {style:'currency',currency:form.dataset.currency || 'EUR'}).format(value);
  const cards = Array.from(form.querySelectorAll('[data-native-catalog-pack]'));
  // Reference ("van") price per unit: the variant's compare-at price when higher than the price, like the competitors.
  const render = compareUnit => cards.forEach(card => {
    const qty = Number(card.dataset.nativeCatalogPack);
    const referenceSingle = Number(card.dataset.unitPrice);
    const referenceTotal = Number(card.dataset.packageTotal);
    // Same maths as the Shopify automatic discount: whole-percent discount on each unit, rounded half up to cents.
    const pct = Math.round((1 - referenceTotal / (referenceSingle * qty)) * 100);
    const total = confirmed ? Math.round(Math.round(price * 100) * (100 - pct) / 100) * qty / 100 : price * qty;
    card.dataset.currentTotal = total;
    card.querySelector('[data-bundle-total]').textContent = format(total);
    const regular = Math.round(Math.max(price, compareUnit || 0) * qty * 100) / 100;
    const saving = Math.max(0, Math.round((regular - total) * 100) / 100);
    card.querySelector('[data-bundle-saving]').textContent = saving > 0 ? 'Bespaar '+format(saving) : '';
    card.querySelector('[data-bundle-regular]').textContent = saving > 0 ? format(regular) : '';
  });
  render(0);
  const variantId = (form.querySelector('[name=id]:checked') || form.querySelector('[name=id]'))?.value;
  fetch(location.pathname.replace(/\/$/, '') + '.js').then(r => r.json()).then(product => {
    const variant = product.variants.find(v => String(v.id) === String(variantId)) || product.variants[0];
    if (variant && variant.compare_at_price > variant.price) { render(variant.compare_at_price / 100); update(); }
  }).catch(() => {});
  const update = () => {
    const selected = cards.find(card => card.querySelector('input').checked);
    if (!selected) return;
    const total = Number(selected.dataset.currentTotal);
    const priceNode = form.querySelector('#selected-total');
    if (priceNode) priceNode.textContent = format(total);
    const sticky = document.querySelector('.sticky-buy small');
    if (sticky) sticky.textContent = format(total);
  };
  form.querySelectorAll('[name=quantity]').forEach(input => input.addEventListener('change', update));
  form.querySelectorAll('[data-native-variant]').forEach(input => input.addEventListener('change',()=>{
    const url=new URL(location.href);url.searchParams.set('variant',input.value);location.assign(url.href);
  }));
  if (form.querySelector('[data-sold-out]')) document.querySelectorAll('[data-native-add]').forEach(button => {button.disabled=true;button.textContent='Uitverkocht';});
  update();
  document.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click',()=>document.querySelector('.gallery-tabs')?.scrollBy({left:240*Number(button.dataset.galleryStep),behavior:'smooth'})));
})();
